<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search" style="flex-wrap: wrap; row-gap: 10px;">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="编号" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.project_id"  clearable filterable  placeholder="项目">
                                        <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}<small>{{item.status_name}}</small></Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.buyer_id"  clearable filterable  placeholder="采购">
                                        <Option :value="item.buyer_id" v-for="(item,index) in buyerList" :key="index">{{item.title}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.company_id"  clearable filterable  placeholder="供应商">
                                        <Option :value="item.company_id" v-for="(item,index) in companyList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.type_id"  clearable filterable  placeholder="支付类型">
                                        <Option :value="item.id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.apply_id"  clearable filterable  placeholder="申请人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="状态" class="search-select">
                                        <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.is_invoice" clearable placeholder="发票状态" class="search-select">
                                        <Option :value="1">不开票</Option>
                                        <Option :value="2">待开票</Option>
                                        <Option :value="3">未全额开票</Option>
                                        <Option :value="4">已开票</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn " style="white-space: nowrap;">
                                    <ButtonGroup  style="display:flex; white-space: nowrap;">
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建支出</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                        <Button v-if="$store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2" type="success" size="small" class="text-font-sm" @click="exportData"><Icon type="md-paper-plane" /> 导出数据</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #sn="{ row }">
                                    <div class="d-width text-primary cursor" :title="row.sn" @click="showData(row.expend_id)">
                                        <span>{{row.sn}}</span>
                                    </div>
                                </template>
                                <template #type_id="{ row }">
                                    <Tag>{{row.type_name}}</Tag>
                                </template>
                                <template #money="{ row }">
                                    <div class="d-width" :title="row.money?row.money:'0.00'">
                                        <strong class="text-primary">{{row.money?row.money:'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #tax_rate="{ row }">
                                    <span>{{row.tax_rate}} %</span>
                                </template>
                                <template #true_money="{ row }">
                                    <div class="d-width" :title="row.true_money?row.true_money:'0.00'">
                                        <strong class="text-success">{{row.true_money?row.true_money:'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #pay_money="{ row }">
                                    <div class="d-width" :title="row.pay_money?row.buyer_money:'0.00'">
                                        <strong class="text-success">{{row.pay_money?row.pay_money:'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #pay_time="{ row }">
                                    {{row.pay_time ?? '-'}}
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1 || row.status === 2 || row.status === 3" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 5" color="orange" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 7" color="green" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 4 || row.status === 6" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #invoice_image="{ row }">
                                    <Badge v-if="row.is_invoice === 1" color="#999" :text="row.is_invoice_name" />
                                    <Badge v-else-if="row.is_invoice === 2" color="blue" :text="row.is_invoice_name" />
                                    <Badge v-else-if="row.is_invoice === 3" color="orange" :text="row.is_invoice_name" />
                                    <Badge v-else-if="row.is_invoice === 4" color="green" :text="row.is_invoice_name" />
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #project_id="{ row }">
                                    <div class="d-width" :title="row.project_name ?? '-'">
                                        {{row.project_name ?? '-'}}
                                    </div>
                                </template>
                                <template #buyer_id="{ row }">
                                    <div class="d-width" :title="row.buyer_title ?? '-'">
                                        {{row.buyer_title ?? '-'}}
                                    </div>
                                </template>
                                <template #company_id="{ row }">
                                    <div class="d-width" :title="row.company ?? '-'">
                                        {{row.company ?? '-'}}
                                    </div>
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-font-sm text-violet" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2) && (row.status === 1 || row.status === 2) " @click="examineExpendData(row.expend_id)">审批</a>
                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2) && (row.status === 1  || row.status === 2)"/>
                                    <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 5 " @click="payExpendData(row.expend_id)">打款</a>
                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 5 "/>
                                    <a class="text-font-sm text-primary" v-if="row.status !== 7" @click="editData(row.expend_id)">编辑</a>
                                    <Divider type="vertical" v-if="row.status !== 7"/>
                                    <a class="text-font-sm text-danger" v-if="row.status !== 7" @click="deleteData(row.expend_id, index)">删除</a>
                                    <a class="text-font-sm text-success" @click="showData(row.expend_id)" v-if="row.status === 7">查看</a>
                                    <Divider type="vertical" v-if="row.status === 7 && $store.state.userinfo.group_id === 1"/>
                                    <a class="text-font-sm text-warning" @click="rateData(row.expend_id)" v-if="row.status === 7 && $store.state.userinfo.group_id === 1">费率调整</a>
<!--                                    <Divider type="vertical" v-if="row.invoice_image.length <= 0"/>-->
<!--                                    <a class="text-font-sm text-orange" v-if="row.invoice_image.length <= 0" @click="addInvoiceData(row.expend_id)">发票</a>-->
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 费率调整  -->
                    <rate-modal v-if="is_rate" ref="RateRef" @trueHandler="saveData"></rate-modal>

                    <!-- 项目支出审批  -->
                    <examine-modal v-if="is_expend_examine" ref="ExamineExpendRef" @trueHandler="saveData"></examine-modal>

                    <!-- 项目支出财务打款  -->
                    <pay-expend-modal v-if="is_expend_pay" ref="PayExpendRef" @trueHandler="saveData"></pay-expend-modal>

                    <!-- 项目支出详情  -->
                    <show-expend-modal v-if="is_show" ref="ShowExpendRef"></show-expend-modal>

                    <!-- 上传支出发票  -->
                    <invoice-expend-modal v-if="is_expend_invoice" ref="InvoiceExpendRef" @trueHandler="saveData"></invoice-expend-modal>

                    <Modal
                        v-model="is_export"
                        title="导出数据"
                        @on-ok="onExport"
                        :loading="export_loading"
                        width="800px"
                        ok-text="立即导出"
                        @on-cancel="cancelExport">
                        <Row :gutter="32">
                            <Col :span="24">
                                <Form ref="SearchForms" :model="SearchForms" :rules="SearchRules"  label-position="left">
                                    <Row :gutter="32">
                                        <Col :span="24">
                                            <FormItem label="项目" prop="project_id">
                                                <Select class="search-select"  v-model="SearchForms.project_id"  clearable filterable  placeholder="选择项目">
                                                    <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="采购" prop="buyer_id">
                                                <Select class="search-select" v-model="SearchForms.buyer_id"  clearable filterable  placeholder="选择采购">
                                                    <Option :value="item.buyer_id" v-for="(item,index) in buyerList" :key="index">{{item.title}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="供应商" prop="company_id">
                                                <Select class="search-select" v-model="SearchForms.company_id"  clearable filterable  placeholder="选择供应商">
                                                    <Option :value="item.company_id" v-for="(item,index) in companyList" :key="index">{{item.company}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="支付类型" prop="type_id">
                                                <Select class="search-select"   v-model="SearchForms.type_id"  clearable filterable  placeholder="选择收入类型">
                                                    <Option :value="item.id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="申请人" prop="apply_id">
                                                <Select class="search-select"   v-model="SearchForms.apply_id"  clearable filterable  placeholder="选择申请人">
                                                    <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="状态" prop="status">
                                                <Select class="search-select"   v-model="SearchForms.status"  clearable filterable  placeholder="选择状态">
                                                    <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="申请日期" prop="time">
                                                <DatePicker class="width-100" v-model="SearchForms.time" clearable type="daterange" format="yyyy-MM-dd"  placeholder="选择日期" />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                    </Modal>
                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "../Create";
import ExamineModal from "../Examine";
import RateModal from "../Rate";
import PayExpendModal from "../Pay";
import ShowExpendModal from "../Show";
import invoiceExpendModal from "../Invoice";
import {getExpendConfig, getExpendList, deleteExpend, exportExpend} from "@/apis/expend";
export default {
    name: "ExpendIndex",
    components: {
        Headers, Side, AddModal, ExamineModal, RateModal, PayExpendModal, ShowExpendModal, invoiceExpendModal
    },
    data () {
        return {
            projectList: [],
            buyerList: [],
            companyList: [],
            typeList: [],
            userList: [],
            statusList: [],

            search: {
                is_invoice: '',
                name: '',
                project_id: '',
                buyer_id: '',
                company_id: '',
                type_id: '',
                apply_id: '',
                status: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '编号',
                    key: 'sn',
                    slot: 'sn',
                    fixed:'left',
                    width: 160,
                },
                {
                    title: '支出类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width: 120,
                },
                {
                    title: '申请金额',
                    key: 'money',
                    slot: 'money',
                    width: 120,
                },
                {
                    title: '费率',
                    key: 'tax_rate',
                    slot: 'tax_rate',
                    width: 100
                },
                {
                    title: '税费',
                    key: 'tax_money',
                    width: 120
                },
                {
                    title: '实收',
                    key: 'true_money',
                    slot: 'true_money',
                    width: 120
                },
                {
                    title: '支付金额',
                    key: 'pay_money',
                    slot: 'pay_money',
                    width: 120
                },
                {
                    title: '支付时间',
                    key: 'pay_time',
                    slot: 'pay_time',
                    width: 120
                },
                {
                    title: '状态',
                    key: 'status',
                    slot : 'status',
                    width:120
                },
                {
                    title: '发票',
                    key: 'invoice_image',
                    slot : 'invoice_image',
                    width:120
                },
                {
                    title: '项目',
                    key: 'project_id',
                    slot: 'project_id',
                    minWidth: 120
                },
                {
                    title: '采购信息',
                    key: 'buyer_id',
                    slot: 'buyer_id',
                    minWidth: 120
                },
                {
                    title: '供应商',
                    key: 'company_id',
                    slot: 'company_id',
                    minWidth: 120
                },
                {
                    title: '申请人',
                    key: 'apply_name',
                    width:120
                },
                {
                    title: '更新',
                    key: 'update_time',
                    width:150
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    width : 150,
                    fixed : 'right'
                }
            ],
            is_create : false,
            is_expend_examine : false,
            is_rate : false,
            is_expend_pay : false,
            is_show : false,
            is_expend_invoice : false,

            is_export : false,
            export_loading : true,
            SearchForms: {
                project_id: '',
                buyer_id: '',
                company_id: '',
                type_id: '',
                apply_id: '',
                status: '',
                time: []
            },
            SearchRules: {},
            site_url : this.$siteApi,

        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        exportData(){
            let that = this;
            that.is_export =  true;
        },
        onExport(){
            let that = this;
            exportExpend({search:that.SearchForms}).then( e =>{
                that.$Message.success({ background: true,duration:3, content:e.msg});
                if(e.data){
                    //下载文件
                    const fileUrl = that.site_url + e.data.url; // 文件的URL地址
                    const parts = fileUrl.split('/');
                    const fileName = parts[parts.length - 1];
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.target = '_blank';
                    link.setAttribute('download', fileName);
                    link.click();
                }else{
                    that.$Message.error({ background: true,duration:3, content: '没有文件可下载'});
                }
                that.cancelExport();
            })
        },
        cancelExport(){
            let that = this;
            that.is_export =  false;
            that.SearchForms = {
                project_id: '',
                buyer_id: '',
                company_id: '',
                type_id: '',
                apply_id: '',
                status: '',
                time: []
            }
        },
        addInvoiceData(project_id){
            let that = this;
            that.is_expend_invoice = true;
            setTimeout(function(){
                that.$refs.InvoiceExpendRef.edit(project_id);
            })
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                is_invoice: '',
                name: '',
                project_id: '',
                buyer_id: '',
                company_id: '',
                type_id: '',
                apply_id: '',
                status: ''
            };
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 14:05
         **/
        getConfig(){
            let that = this;
            getExpendConfig().then(e=>{
                that.projectList = e.data.projectList ?? [];
                that.buyerList = e.data.buyerList ?? [];
                that.companyList = e.data.companyList ?? [];
                that.typeList = e.data.expendTypeList ?? [];
                that.userList = e.data.userList ?? [];
                that.statusList = e.data.statusList ?? [];
            })
        },
        /**
         功能：列表
         time: 2025-09-01 18:09:28
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getExpendList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：分页
         time: 2025-54-03 09:54:43
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },

        /**
         功能：创建
         time: 2025-26-02 09:26:21
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：
         time: 2025/12/27 10:22
         **/
        editData(expend_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(expend_id);
            })
        },
        /**
         功能：费率调整
         time: 2026/1/6 15:18
         **/
        rateData(expend_id){
            let that = this;
            that.is_rate = true;
            setTimeout(function(){
                that.$refs.RateRef.edit(expend_id);
            })
        },
        /**
         功能：
         time: 2026/1/6 15:18
         **/
        showData(expend_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowExpendRef.show(expend_id);
            })
        },

        /**
         功能：
         time: 2025/12/27 10:54
         **/
        examineExpendData(expend_id){
            let that = this;
            that.is_expend_examine = true;
            setTimeout(function(){
                that.$refs.ExamineExpendRef.show(expend_id);
            })
        },
        /**
         功能：
         time: 2025/12/27 11:35
         **/
        payExpendData(expend_id){
            let that = this;
            that.is_expend_pay = true;
            setTimeout(function(){
                that.$refs.PayExpendRef.show(expend_id);
            })
        },

        /**
         功能：操作返回
         time: 2025-26-02 09:26:53
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/27 10:33
         **/
        deleteData(expend_id, index){
            let that = this;
            if(!expend_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteExpend(expend_id).then( e =>{
                        that.dataList.data.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
